import FormHandler, { GoogleV2 } from '../grit-form-handler';
import { msg } from '../main';

export const INIT_terms = () => {
  const gRecaptchaSiteKey = document
    .querySelector("meta[name='google_recaptcha_site_key']")
    .getAttribute('content');

  const termsForm = document.getElementById('form_contractor_accept_terms');

  if (termsForm) {
    const dataAlerts = termsForm.dataset.formAlerts;

    termsForm.addEventListener('submit', () => {
      document.body.classList.add('is-loading');
    });

    new FormHandler(`#${termsForm.id}`, {
      // recaptcha: new GoogleV2(gRecaptchaSiteKey),
      recaptcha: false,
      flashMessage: msg,
      resetOnSuccess: false,
      localisation: {
        success: dataAlerts.success
          ? dataAlerts.success
          : 'Thank you for your submission.',
        error: dataAlerts.error
          ? dataAlerts.error
          : 'There was an error with your submission.',
      },
      scrollToError: {
        enabled: true,
        offset: 0,
      },
      validate: {
        onChange: true,
        onSubmit: true,
      },
      onSuccess: (form, res) => {
        setTimeout(() => {
          location.reload();
        }, 300);
      },
      onError: (form, res) => {
        const alertMessages = JSON.parse(termsForm.dataset.formAlerts);
        msg.flash(alertMessages.error, false);

        document.body.classList.remove('is-loading');
      },
    });
  }
};
